import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-auth',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: '',
})
export class AuthComponent {}
